import React from 'react';
import { Link } from 'react-router-dom';
import { usePortal } from '../../../context/PortalContext';
import PortalPageShell, { PortalEmpty } from '../PortalPageShell';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';

export default function PortalParentChildren() {
  const { children } = usePortal();

  return (
    <PortalPageShell title="My children" description="Linked student profiles">
      {children.length === 0 ? <PortalEmpty message="No children linked to your account. Contact school admin." /> : null}
      <div className="grid gap-4 md:grid-cols-2">
        {children.map((c) => (
          <Card key={c.id}>
            <CardHeader>
              <CardTitle className="text-lg">{c.first_name} {c.last_name}</CardTitle>
              <p className="text-sm text-muted-foreground">
                {c.admission_no} · {c.class_name}{c.section_name ? ` ${c.section_name}` : ''}
              </p>
            </CardHeader>
            <CardContent className="flex flex-wrap gap-2">
              <Button asChild size="sm" variant="outline">
                <Link to={`/portal/parent/child/${c.id}`}>View profile</Link>
              </Button>
              {c.pending_fees > 0 ? (
                <span className="text-sm text-amber-600">Pending fees: ₹{c.pending_fees}</span>
              ) : null}
            </CardContent>
          </Card>
        ))}
      </div>
    </PortalPageShell>
  );
}
